import React, {useEffect, useState} from "react";
import {NavPanelRow, DashboardUsersList, DashboardRoomsList} from "../widgets";
import DishIcon from "../../../icons/DishIcon"
import ServiceIcon from "../../../icons/ServiceIcon";
import RoomIcon from "../../../icons/RoomIcon";
import UsersIcon from "../../../icons/UsersIcon";
import ConnectionIcon from "../../../icons/ConnectionIcon";
import FilesIcon from "../../../icons/FilesIcon";
import LibraryIcon from "../../../icons/LibraryIcon";
import {useSubheader} from "../../layout";
import makeRequest from "../../../app/api/makeRequest";
import {useTranslation} from "react-i18next";
import {Backdrop, Fade, Modal} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import RecordIcon from "../../../icons/RecordIcon";
import OfferBar from "../../../app/components/OfferBar";

export function Demo3Dashboard() {
	const suhbeader = useSubheader();
	const { t } = useTranslation('common')

	suhbeader.setTitle(t('MENU.DASHBOARD'));

	const [Rooms, setRooms] = useState([])
	const [Users, setUsers] = useState([])


	useEffect(() => {
		const query = {
			per_page:15
		}
		const getRooms = async () => {
			try {
				const {data} = await makeRequest('getRooms', {},query)
				const rooms = data.rooms.docs
				setRooms(rooms)
			} catch (e) {
				console.log(e)
			}
		}

		getRooms()

		const getUsers = async () => {
			try {
				const {data} = await makeRequest('getUsers', {},query)
				const users = data.users.docs
				setUsers(users)
			} catch (e) {
				console.log(e)
			}
		}

		getUsers()
	}, [])

	const NavPanels = [
		// {
		// 	link: '/service',
		// 	text: t('Services'),
		// 	icon: ServiceIcon
		// },
		{
			link: '/room',
			text: t('Rooms'),
			icon: RoomIcon
		},
		{
			link: '/user',
			text: t('Users'),
			icon: UsersIcon
		},
		{
			link: '/session',
			text: t('Sessions'),
			icon: DishIcon
		},
		{
			link: '/connection',
			text: t('Connections'),
			icon: ConnectionIcon
		},
		{
			link: '/file',
			text: t('Files'),
			icon: FilesIcon
		},
		{
			link: '/library',
			text: t('Library'),
			icon: LibraryIcon
		},
		{
			link: '/record',
			text: t('Record'),
			icon: RecordIcon
		},
	]
	const useStyles = makeStyles((theme) => ({
		root: {
			width: '100%',
		},
		button: {
			marginRight: theme.spacing(1),
			color:"white",
			backgroundColor:"#ff9800"
		},
		instructions: {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
		},
		modal: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 4, 3),
		},
	}));

	const classes = useStyles();
	const [open, setOpen] = React.useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			{/* begin::Dashboard */}

			{/* begin::Row */}
			<OfferBar/>
			<div className="help">
				<div className="content">
					<a href="#" onClick={handleOpen} className={'help'}>
						<span></span>
						<span></span>
						<span></span>
						<span></span>
						{t('SeeGuide')}
					</a>
					<Modal
						aria-labelledby="transition-modal-title"
						aria-describedby="transition-modal-description"
						className={classes.modal}
						open={open}
						onClose={handleClose}
						closeAfterTransition
						BackdropComponent={Backdrop}
						BackdropProps={{
							timeout: 500,
						}}
					>
						<Fade in={open}>
							<div>
								<video style={{
									margin: "0 auto",
									display: "block"
								}} width="95%"  controls>
									<source src={t('lang') === 'fa' ? 'https://bellmeet.com/helpvideo/15.mp4' : 'https://bellmeet.com/helpvideo/16.mp4'} type="video/mp4" />
									Your browser does not support the video tag.
								</video>
							</div>
						</Fade>
					</Modal>
				</div>
			</div>
			<div className="row">
				<div className="col-xl-8">
					<div className="row">
						<div className="col-xl-12">
							<NavPanelRow NavPanels={NavPanels}/>
						</div>
						<div className="col-xl-12">
							<DashboardRoomsList rooms={Rooms} onDelete={(id)=>{
								setRooms(prev=>prev.filter(q=>q.id !== id))
							}}/>
						</div>
					</div>

					{/*<BaseTablesWidget6 className="gutter-b" />*/}
				</div>
				<div className="col-xl-4">
					<DashboardUsersList users={Users} onDelete={(id)=>{
						setUsers(prev=>prev.filter(q=>q.id !== id))
					}}/>
				</div>
			</div>
			<div className="separator separator-dashed mt-8 mb-5"/>

			{/* end::Row */}


			{/* end::Dashboard */}
		</>
	);
}
